<template>
  <v-row>
    <v-col v-if="!$store.state.USER.emailVerified" class="py-0" cols="12">
      <v-alert class="mb-0" type="error">您的邮箱尚未激活。</v-alert>
    </v-col>
    <v-col cols="8">
      <v-row>
        <uCard title="基本" :cols="12" :actions="[{content: '启动游戏', disabled: true}]">
          <v-card-text>
            <v-row class="mx-8">
              <v-col cols="12">
                <h3>性能</h3>
                <v-alert type="info">该功能需要您启动Nyan启动器后方可使用。</v-alert>
              </v-col>
              <v-col cols="6" class="py-0">
                <h3>云服务</h3>
                <v-card color="teal" dark>
                  <v-card-text class="my-2">
                    同步云空间
                    <v-progress-linear height="7" class="my-3" color="white" value="0"></v-progress-linear>
                    <p class="my-0 text-right">0MB/50MB</p>
                  </v-card-text>
                </v-card>
                <v-card color="cyan" dark>
                  <v-card-text class="my-2">
                    皮肤库存储
                    <v-progress-linear height="7" class="my-3" color="white" value="0"></v-progress-linear>
                    <p class="my-0 text-right">0KB/1024KB</p>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="6" class="py-0">
                <h3>账户</h3>
                <v-card color="grey lighten-3 my-2" flat>
                  <v-card-text class="py-2">
                    我的Pixel
                  </v-card-text>
                  <v-card-title class="py-0">
                    {{$store.state.USER.pixel}}
                  </v-card-title>
                  <v-card-text class="py-2">
                    <p class="my-0 text-end">个</p>
                  </v-card-text>
                </v-card>
                <v-card color="grey lighten-3 my-2" flat>
                  <v-card-text class="py-2">
                    我的绿宝石
                  </v-card-text>
                  <v-card-title class="py-0">
                    {{$store.state.USER.emerald}}
                  </v-card-title>
                  <v-card-text class="py-2">
                    <p class="my-0 text-end">颗</p>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </uCard>
        <!-- <uCard title="Yggdrasill启动器配置" :cols="6" :actions="[{content: '复制API地址'}]">
          <v-card-text>
            我们目前使用了外置登陆(authib-injector)，需要在启动器配置API地址。
            <br />我们的api地址为
            <kbd>https://api.makjust.com/2/auth</kbd>，您也可点击下方的按钮复制。
          </v-card-text>
        </uCard> -->
        <uCard title="Auth Login" :cols="6">
          <v-card-text>
            我们目前临时使用了Auth Login服务，您只需直接在游戏中注册、登陆，后期我们会同步到MAKjustID。
          </v-card-text>
        </uCard>
      </v-row>
    </v-col>
    <v-col cols="4">
      <v-row>
        <uCard title="站内公告" :cols="12">
          <v-card-text style="overflow: auto;max-height: 260px">
            <div v-if="accLoading">
              <v-skeleton-loader class="mx-auto" type="image"></v-skeleton-loader>
            </div>
            <v-row v-else>
              <v-col cols="12" v-for="(r,i) in accList" :key="`_INDEX-ANNOUNCEMENT-${i}`">
                <v-card outlined>
                  <v-card-title>{{r.title}}</v-card-title>
                  <v-card-text>{{r.content}}</v-card-text>
                  <v-card-actions v-if="r.actions">
                    <v-spacer></v-spacer>
                    <v-btn
                      v-for="(btn, i) in r.actions"
                      :key="`_INDEX-AMMCOUCEMENT-BTN-${i}`"
                      text
                      :href="btn.link"
                    >{{btn.name}}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </uCard>
        <uCard title="操作日志" :cols="12" :actions="[{content: '修改密码',to:'/user/account#repassword'}]">
          <v-card-text>
            <v-alert type="info">该功能暂时处于开发阶段。</v-alert>
          </v-card-text>
        </uCard>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import mjp from "../../plugins/makjust";
import uCard from "../../components/userBoxCard";
export default {
  data() {
    return {
      accList: [],
      accLoading: true
    };
  },
  mounted() {
    //getAnn
    mjp.getNotice().then(ann => {
      if (!ann.code) {
        let _ann = ann.data.results;
        _ann.sort((a, b) => {
          return new Date().getTime(a.createdAt) >
            new Date().getTime(b.createdAt)
            ? 1
            : -1;
        });
        this.accList = _ann;
        this.accLoading = false;
      }
    });
  },
  methods:{
  },
  components: {
    uCard
  }
};
</script>